<template>
    <validation-provider v-slot="v" :name="name" :rules="rules" slim mode="eager">
        <div class="form-group mb-0"
             :class="{
                 'has-feedback has-error': v.errors.length,
                 'row': inline && isLabelSlot,
                 'd-flex': inline && isLabelSlot,
             }">
            <label v-if="isLabelSlot" :for="id" :class="labelClass" class="mb-0 mt-2">
                <slot name="label"/>
            </label>
            <div :class="{'col-md-7':labelClass.length}">
                <date-picker :id="id"
                             v-model="val"
                             :range="range"
                             :input-attr="{name: name, id: id, placeholder: placeholder}"
                             :input-class="`form-control h-40px ${v.errors.length ? 'is-invalid no-icon' : ''} ${!noCustomBg ? 'custom-green-input-bg' : ''}`"
                             :format="inputFormat"
                             :minute-step="minuteStep"
                             :type="inputType"
                             :disabled="disabled"
                             :open.sync="open"
                             :lang="lang"
                             @change="handleChange"
                             @blur="onBlur"
                             :disabled-date="disabledB4Today"
                             valueType="format">
                    <template v-if="inputType === 'time'" #icon-calendar>
                        <fa-icon :icon="['far', 'clock']"/>
                    </template>
                </date-picker>
                <div class="invalid-feedback" :class="{'d-block': v.errors.length}">
                    {{ v.errors[0] }}
                </div>
            </div>
        </div>
    </validation-provider>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'AppDatepicker',
    props: {
        id: [String, Number],
        value: [String, Date, Array],
        inline: Boolean,
        range: Boolean,
        noCustomBg: Boolean,
        disabled: Boolean,
        disabledBeforeToday: Boolean,
        inputType: {
            type: String,
            default: 'date'
        },
        minuteStep: {
            type: Number,
            default: 15
        },
        name: String,
        placeholder: String,
        rules: String
    },
    data() {
        return {
            open: false,
            disabledBefore: new Date(Date.now())
        };
    },
    watch: {
        value(val, oldVal) {
            if (val !== oldVal) {
                this.$emit('change', val);
            }
        }
    },
    computed: {
        ...mapGetters(['locale', 'localeDateFormat', 'localeDatetimeFormat']),
        lang() {
            return {
                formatLocale: {
                    firstDayOfWeek: 1,
                    monthsShort: this.locale == 'en' ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] : ['Jan', 'Veb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Det'],
                    weekdaysMin: this.locale == 'en' ? ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'] : ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
                },
            };
        },
        inputFormat() {
            if (this.inputType === 'datetime') {
                return this.localeDatetimeFormat;
            }
            if (this.inputType === 'time') {
                return 'HH:mm';
            }
            return this.localeDateFormat;
        },
        val: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        labelClass() {
            if (this.inline) {
                return 'col-md-3 col-form-label text-md-right';
            }

            return '';
        },
        isLabelSlot() {
            return !!this.$slots.label;
        }
    },
    methods: {
        disabledB4Today(date) {
            if (this.disabledBeforeToday) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                return date < today;
            }
        },
        handleChange(value, type) {
            if (type === 'minute' && this.range === false) {
                this.open = false;
                this.$emit('change', value);
            }
        },
        onBlur(e) {
            this.$emit('blur', e);
        },
    },
};
</script>
<style>
    .mx-input-wrapper {
        height: 40px;
    }
    .h-40px {
        height: 40px!important;
    }
    .mx-datepicker {
        width: 100%;
        height: 40px;
        border-radius: 2px;
    }
</style>
